<template>
  <el-container>
    <el-header>
      <div class="logo">
        <img src="../assets/logo1.png" alt="" width="60"/>
      </div>
    </el-header>
    <el-main>
      <el-row>
        <el-col :sm="{ span: 20, offset: 2 }" :lg="{ span: 18, offset: 3 }">
          <el-card class="summary-card">
            <el-row type="flex" align="center" justify="between">
              <el-col :span="8">
                <p>我的待办</p>
                <p>{{ list.length }} 个发货单</p>
              </el-col>
              <el-col :span="8">
                <p>订单组状态</p>
                <p>
                  {{ group.groupName }} /
                  <span :class="[group.status == '0' ? 'doing' : 'finnish']">{{ group.groupStatusName }}</span>
                </p>
              </el-col>
              <el-col :span="8">
                <p>当前农场</p>
                <p>{{ farm.farmName }}</p>
              </el-col>
            </el-row>
          </el-card>
        </el-col>
      </el-row>
      <el-row class="block">
        <el-col>
          <el-card>
            <el-row type="flex" style="margin-bottom:10px" justify="space-between">
              <div>
                <el-select v-model="masterSelected" class="masterSelect" size="mini" placeholder="设定默认快递公司">
                  <el-option v-for="item in express" :key="item.id" :value="item.code" :label="item.name"></el-option>
                </el-select>
                <span>仅为方便一次性修改所有订单快递公司，具体提交快递公司以订单中快递公司选项为准</span>
              </div>

              <div style="display:flex;flex-justify:end">
                <el-button type="primary" @click="downDeliveryItem" icon="el-icon-download" size="mini">{{
                    btnDownloadText
                  }}
                </el-button>
                <upload-excel-component :on-success="handleSuccess"/>
              </div>
            </el-row>
            <el-table
                :border="true"
                @selection-change="orderselectChange"
                header-cell-class-name="table-header"
                :span-method="spanTable"
                :data="list"
                ref="multipleTable"
                tooltip-effect="dark"
            >
              <el-table-column type="selection" width="40"></el-table-column>
              <el-table-column label="产品名称">
                <template slot-scope="scope">
                  <p>{{ scope.row.skuName }} <span
                      :style="{color:scope.row.skuNum>1?'#F56C6C':'#303133',fontSize:16+'px'}">x{{
                      scope.row.skuNum
                    }}</span></p>
                </template>
              </el-table-column>
              <el-table-column label="收货人">
                <template slot-scope="scope">
                  <p>
                    {{ scope.row.name }} <small>{{ scope.row.phone }}</small>
                  </p>
                  <p>{{ scope.row.address }}</p>
                </template>
              </el-table-column>
              <el-table-column width="200" label="快递公司">
                <template slot-scope="scope">
                  <el-select
                      @change="
                      val => {
                        singleSelectChange(scope.row.deliveryId, val)
                      }
                    "
                      v-model="scope.row.expressCode"
                      placeholder="当前订单快递公司"
                  >
                    <el-option v-for="item in express" :key="item.id" :value="item.code" :label="item.name"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column width="200" label="回填单号">
                <template slot-scope="scope">
                  <el-input
                      @input="inputCode(scope.row.deliveryId, scope.row.code)"
                      v-model="scope.row.code"
                      placeholder=""
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column width="100" label="操作">
                <template slot-scope="scope">
                  <el-link
                      @click="
                      unableSend({
                        type: scope.row.type,
                        orderItemId: scope.row.orderItemId,
                        deliveryId: scope.row.deliveryId
                      })
                    "
                      type="primary"
                  >无法发出
                  </el-link
                  >
                </template>
              </el-table-column>
            </el-table>
            <el-button type="primary" :disabled="list.length == 0" @click="onSubmit" icon="el-icon-finished"
            >确定提交
            </el-button
            >
          </el-card>
        </el-col>
      </el-row>
    </el-main>
  </el-container>
</template>

<script>
import request from "@/util/request"
import {Message} from "element-ui"
import uploadExcelComponent from "@/components/uploadExcel"

const dic = {deliveryId: "id勿删", code: "快递单号"}
const sys = process.env.VUE_APP_SYS_KEY
export default {
  name: "dashboard",
  components: {uploadExcelComponent},
  data() {
    return {
      group: {},
      farm: {},
      orderGroupStatus: 1,
      orderNum: 0,
      selectOrder: [],
      list: [],
      spanArr: [],
      position: 0,
      express: [],
      masterSelected: ""
    }
  },
  created() {
    const groupId = this.$route.query.groupId
    this.getData(groupId)
    try {
      this.getOrderGroup(groupId).then(group => {
        switch (group[0].status) {
          case "0":
            group[0].groupStatusName = "进行中"
            break
          case "1":
            group[0].groupStatusName = "已完成"
            break
          case "2":
            group[0].groupStatusName = "已取消"
            break
        }
        this.group = group[0]
        this.getFarm(this.group.farmId).then(res => {
          this.farm = res
        })
      })
    } catch (error) {
      //   console.log(error)
    }
    this.getExpressCode()
  },
  computed: {
    btnDownloadText: function () {
      const count = this.selectOrder.length
      if (count == 0) {
        return "下载所有订单"
      }
      return "下载选择的[ " + count + " ]个订单"
    }
  },
  watch: {
    masterSelected: function (v) {
      for (let i = 0; i < this.list.length; i++) {
        this.list[i].expressCode = v
      }
    }
  },
  methods: {
    onSubmit() {
      const list = this.list

      let index = list.findIndex(ele => ele.code == "")
      if (index != -1) {
        Message({
          type: "error",
          message: "快递单号不能为空，如果无法发出，请点选对应的【无法发出】",
          duration: 5 * 1000
        })
        return
      }
      let expressCodeIndex = list.findIndex(ele => ele.expressCode == "")
      if (expressCodeIndex != -1) {
        Message({
          type: "error",
          message: "快递公司不能为空",
          duration: 5 * 1000
        })
        return
      }

      //   console.log(list)
      request({
        method: "POST",
        url: "/gengfu/express/sendExpressWeb",
        data: {
          groupId: this.group.groupId,
          list: JSON.stringify(this.list)
        }
      }).then(res => {
        Message({
          type: "success",
          message: res,
          duration: 1000
        })
        setTimeout(() => {
          location.reload()
        }, 1000)
      })
    },
    inputCode(deliveryId, code) {
      //   console.log(deliveryId, code)
      for (let i = 0; i < this.list.length; i++) {
        if (this.list[i].deliveryId == deliveryId) {
          this.list[i].code = code
        }
      }
    },
    singleSelectChange(deliveryId, expressCode) {
      for (let i = 0; i < this.list.length; i++) {
        if (this.list[i].deliveryId == deliveryId) {
          this.list[i].expressCode = expressCode
        }
      }
    },
    unableSend(e) {
      //   console.log(e)
      const {deliveryId, orderItemId, type} = e
      request.post("/gengfu/express/unableSend", {deliveryId, type}).then(res => {
        Message({
          type: "success",
          message: res,
          duration: 5 * 1000
        })
      })
      let newList = []
      if (type == "0") {
        newList = this.list.filter(ele => ele.deliveryId != deliveryId)
      } else if (type == "1") {
        //分单
        newList = this.list.filter(ele => {
          if (ele.orderItemId == orderItemId) {
            return false
          }
          return true
        })
      } else {
        //合单
        newList = this.list.filter(ele => {
          if (ele.deliveryId == deliveryId) {
            return false
          }
          return true
        })
      }
      this.list = newList

      this.rowspan(0, "deliveryId")
      this.rowspan(1, "orderItemId")
      this.rowspan(2, "deliveryId")
      this.rowspan(3, "deliveryId")
      this.rowspan(4, "deliveryId")
      this.rowspan(5, "deliveryId")
    },
    handleSuccess({results}) {
      //   console.log(results)
      results.forEach(item => {
        const deliveryId = item[dic.deliveryId]
        const type = this.list.find(ele => ele.deliveryId == deliveryId)["type"]
        const code = item[dic.code]

        if (type == 2) {
          let tempIndex = []
          this.list.filter((ele, index) => {
            if (ele.deliveryId == deliveryId) {
              tempIndex.push(index)
              return true
            }
            return false
          })
          tempIndex.forEach(ele => {
            this.list[ele].code = code
          })
        } else {
          let index = this.list.findIndex(ele => ele.deliveryId == deliveryId)
          this.list[index].code = code
        }
      })
    },
    orderselectChange(v) {
      this.selectOrder = v
    },
    downDeliveryItem() {
      import("@/util/export2Excel").then(excel => {
        const header = [
          "id勿删",
          "订单编号",
          "商品规格",
          "下单时间",
          "买家备注",
          "收件人姓名",
          "收件人手机",
          "收件人地址",
          "寄件人姓名",
          "寄件人手机",
          "寄件人地址",
          "包裹备注",
          "快递单号"
        ]
        const filterVal = [
          "deliveryId",
          "orderNo",
          "downSkuName",
          "createTime",
          "remark",
          "name",
          "phone",
          "address",
          "senderName",
          "senderPhone",
          "senderAddress"
        ]
        const list = this.selectOrder.length ? this.selectOrder : this.list
        let data = this.formatJson(filterVal, list)
        excel.export_json_to_excel({
          header,
          data,
          filename: this.farm.farmName + "-订单组_" + this.group.groupName,
          autoWidth: true,
          bookType: "xlsx"
        })
      })
    },
    formatJson(filterVal, jsonData) {
      let combine = {}
      let newData = []
      let tempData = []
      for (let i = 0; i < jsonData.length; i++) {
        const item = jsonData[i]
        if (item.type == "2") {
          let index = tempData.findIndex(ele => {
            return ele.deliveryId === item.deliveryId
          })
          if (index === -1) {
            item.downSkuName = item.skuName + "x" + item.skuNum
            tempData.push(item)
          } else {
            tempData[index].downSkuName += " ," + item.skuName + "x" + item.skuNum
            tempData[index].orderNo += " ," + item.orderNo
          }
        } else if (item.type === "1") {
          item.downSkuName = item.skuName + "x" + item.skuNum + "/" + item.deliveryNum
          tempData.push(item)
        } else {
          item.downSkuName = item.skuName + "x" + item.skuNum
          tempData.push(item)
        }
      }
      for (let i = 0; i < tempData.length; i++) {
        let n = filterVal.map(j => {
          switch (j) {
            case "senderName":
              return this.farm.name
            case "senderPhone":
              return this.farm.phone
            case "senderAddress":
              return this.farm.address
            default:
              return tempData[i][j]
          }
        })
        newData.push(n)
      }
      return newData
    },
    getOrderGroup(groupId) {
      if (groupId) {
        return request({
          url: "/gengfu/order/orderGroup",
          data: {groupId},
          method: "POST"
        })
      } else {
        Message({
          type: "error",
          message: "分组ID不能为空",
          duration: 5 * 1000
        })
      }
    },
    getFarm(farmId) {
      if (farmId) {
        return request({
          url: "/gengfu/user/farmInfo",
          data: {farmId},
          method: "POST"
        })
      } else {
        Message({
          type: "error",
          message: "农场ID不能为空",
          duration: 5 * 1000
        })
      }
    },
    getExpressCode() {
      request({
        url: "gengfu/express/getExpressCodeList",
        data: {
          sys: sys
        },
        method: "POST"
      }).then(res => {
        this.express = res
      })
    },
    getData(groupId) {
      request({
        url: "/gengfu/order/getOrderGroupDelivery",
        data: {groupId},
        method: "POST"
      }).then(res => {
        const list = []
        for (let i = 0; i < res.length; i++) {
          const item = res[i]
          //   console.log(item)
          if (item.express.code) {
            continue
          }
          let obj = {
            orderNo: item.orderNo,
            orderId: item.orderId,
            consigneeId: item.consigneeId,
            skuId: item.skuId,
            itemId: item.itemId,
            deliveryId: item.deliveryId,
            orderItemId: item.orderItemId,
            title: item.goodsTitle,
            skuName: item.skuName,
            skuNum: item.skuNum,
            deliveryNum: item.deliveryNum,
            name: item.name,
            phone: item.phone,
            address: item.address,
            type: item.type,
            expressCode: "",
            code: "",
            createTime: item.createTime,
            remark: item.remark,
            status: 1
          }
          list.push(obj)
        }
        this.list = list
        this.rowspan(0, "deliveryId")
        this.rowspan(1, "orderItemId")
        this.rowspan(2, "deliveryId")
        this.rowspan(3, "deliveryId")
        this.rowspan(4, "deliveryId")
        this.rowspan(5, "deliveryId")
      })
    },
    spanTable({rowIndex, columnIndex}) {
      for (let i = 0; i < 6; i++) {
        if (columnIndex === i) {
          const _row = this.spanArr[i][rowIndex]
          const _col = _row > 0 ? 1 : 0
          // console.log('第'+rowIndex+'行','第'+i+'列','rowspan:'+_row,'colspan:'+_col)
          return {
            rowspan: _row,
            colspan: _col
          }
        }
      }
    },
    rowspan(idx, prop) {
      this.spanArr[idx] = []
      this.position = 0
      this.list.forEach((item, index) => {
        if (index === 0) {
          this.spanArr[idx].push(1)
          this.position = 0
        } else {
          if (this.list[index][prop] === this.list[index - 1][prop]) {
            this.spanArr[idx][this.position] += 1 //有相同项
            this.spanArr[idx].push(0) // 名称相同后往数组里面加一项0
          } else {
            this.spanArr[idx].push(1) //同列的前后两行单元格不相同
            this.position = index
          }
        }
      })
    }
  }
}
</script>

<style lang="less">
.masterSelect {
  margin-right: 16px;

  & + span {
    font-size: 12px;
    color: #909399;
  }
}

.el-alert.is-dark.table-tips {
  color: #606266;
  margin-bottom: 10px;
  background: #e6f7ff;
  border: 1px solid #bae7ff;
}

.el-header {
  background: #00182e;
}

.block {
  margin: 50px 0;
}

.el-table {
  margin-bottom: 20px;

  p {
    margin: 2px 0;

    &:last-child {
      color: #909399;
    }
  }

  .table-header {
    background: #fafafa;
    border-top: 1px solid #ebeef5;
  }
}

.summary-card {
  .el-col {
    text-align: center;

    &:not(:nth-last-child(1)) {
      border-right: 1px solid #dcdfe6;
    }
  }

  p {
    &:first-child {
      font-size: 13px;
      color: #909399;
      line-height: 1.5;
    }

    font-size: 18px;
    color: #303133;
    font-weight: bold;
    margin: 10px 0;

    .doing {
      color: #409eff;
    }

    .finish {
      color: #f56c6c;
    }
  }
}

.logo {
  text-align: center;
}
</style>
